import Scrollbars from "react-custom-scrollbars-2";
import { QIDropdown } from "../QIDropdown";
import { FilterChipItem } from "./FilterChipItem";
import { SvgIcon } from "../../containers/Shared";

export const FilteredBox = ({
  activeFilters = [],
  onClearFilter,
  clear = false,
  handleClearAll = () => {},
}) => {
  // Handle clearing individual filters
  const handleClearFilter = (filter) => {
    if (onClearFilter) {
      onClearFilter(filter);
    }
  };

  const firstFilter = activeFilters[0];
  const remainingFilters = activeFilters.slice(1);

  return (
    <div className="advance-filters_filtered-box">
      <h3 className="advance-filters_filtered-box_title">Filter:</h3>
      <div className="qi-filter-chips-container">
        <FilterChipItem filter={firstFilter} onClearFilter={handleClearFilter} />

        {remainingFilters?.length > 0 && (
          <QIDropdown
            className="qi-filter-chip_more"
            toggleComponent={
              <>
                {remainingFilters?.length > 0 && (
                  <span className="qi-filter-chip">+ {remainingFilters.length}</span>
                )}
              </>
            }
          >
            <Scrollbars autoHeight autoHeightMax="150px">
              <div className="flex flex-col gap-1 p-2">
                {remainingFilters.map((filter, index) => (
                  <FilterChipItem filter={filter} onClearFilter={handleClearFilter} key={index} />
                ))}
              </div>
            </Scrollbars>
          </QIDropdown>
        )}
      </div>
      {clear && activeFilters.length > 1 && (
        <SvgIcon
          name="cross"
          title="Clear filter"
          wrapperClass="action-btn"
          onClick={handleClearAll}
          svgClass="icon-cross"
        />
      )}
    </div>
  );
};
